
<div class="maincontainer font-sans">
    <!-- Transparent overlay layer - shown only when settings popup is open -->
    <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
    
    <div class="flex flex-col md:flex-row h-screen">
      <!-- Mobile Header with Menu Toggle -->
      <div class="block md:hidden bg-white p-4 shadow-sm">
        <div class="flex items-center justify-between">
          <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
          <button class="text-gray-600" (click)="toggleMenu()">
            <i class="fas fa-bars text-xl"></i>
          </button>
        </div>
      </div>
  
      <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
      <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
        <div class="flex items-center justify-center h-12 md:h-16 mb-6">
            <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
        </div>
        <div class="mt-4 md:mt-10">
            <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
                <i class="fas fa-th-large mr-3"></i>
                <span>Home</span>
            </a>
            
            <!-- Reports Dropdown Menu -->
            <div class="relative">
                <!-- Reports Menu Header -->
                <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                    <i class="fas fa-file-alt mr-3"></i>
                    <span>Download Reports</span>
                    <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
                </a>
                
                <!-- Dropdown Items -->
                <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                    <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Biological Indicator Report</span>
                    </a>
                    <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Ultrasonic/Washer Report</span>
                    </a>
                    <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Waterline Test Report</span>
                    </a>
                </div>
            </div>
            
            <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetail()">
                <i class="fas fa-database mr-3"></i>
                <span>Biological Indicator Device</span>
            </a>
        </div>
    </div>
    
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <!-- Header -->
        <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
          <div class="flex items-center">
            <h1 class="text-gray-600 text-sm font-medium">
              Dashboard / Ultrasonic Log
            </h1>
          </div>
          <div class="flex items-center">
            <div class="relative">
            </div>
            <div class="flex items-center gap-2 md:gap-4">
              <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
            
              <div class="relative">
                <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                  <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png" />
                  <span class="text-gray-600 hidden sm:inline">{{clinicName}}</span>
                  <i class="fas fa-caret-down ml-auto"></i>
                </div>
                
                <!-- Setting popup with relative positioning and higher z-index -->
                <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                  <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                    <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                    <p class="text-sm"> Manage Account </p>
                  </div>
                  <hr class="mt-2">
                  <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                    <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                    <p class="text-sm"> Change Password </p>
                  </div>
                  <!-- <hr class="mt-2">
                  <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                    <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                    <p class="text-sm"> Activity Log </p>
                  </div> -->
                  <hr class="mt-2">
                  <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                    <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                    <p class="text-sm"> Logout </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
  
        <!-- Main Section -->
        <main class="flex-1 p-4 md:p-6 overflow-auto">
          <p class="font-bold text-xl md:text-2xl mb-2 md:ml-4">Ultrasonic / Washer Log</p>
          <div class="bg-white min-h-screen p-4">
            <div class="bg-white rounded-lg shadow-lg p-4 md:p-2 w-full">
              <p class="ml-2 mb-2 text-muted ">Please Select Your Test</p>
              <div class="flex flex-col md:flex-row mb-8">
                
                <select 
                class="text-lg font-bold shadow-xl rounded-lg bg-gray-200 py-2 pl-4 pr-4 mb-4 md:mb-0 md:w-1/3"
                [(ngModel)]="formData.logType"
                (change)="onLogTypeChange($event)">
                <option value="Ultrasonic Log">Ultrasonic Log</option>
                <option value="Washer Log">Washer Log</option>
              </select>
           
                <div class="flex flex-col sm:flex-row gap-2 py-1 md:ml-auto">
                  <button class="printbtn text-white text-sm px-6 py-1 shadow-xl cursor-pointer hover:shadow-xl" (click)="generatePDF()">
                    Print
                    <i class="fas fa-print text-white ml-2"></i>
                  </button>
                  <a class="visitmorebtn text-muted bg-gray-300 px-6 text-sm py-1 shadow-lg" href="https://penguinhealth.ca/">
                    <p class="mt-3">Visit More </p>
                  </a>
                </div>
              </div>
              <p class="lg:mb-12 md:mb-8 sm:mb-8 text-lg  font-bold">Add Information</p>
              <div class="title mb-6">
                <p>Results</p>
              </div>
              
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
             
                <div>
                    <label class="fieldsHeading">Sample Date</label>
                    <input 
                      class="w-full p-3 md:p-3 fields mt-2" 
                      type="datetime-local" 
                      [(ngModel)]="formData.date"
                      [value]="currentDateTime"
                    />
                  </div>
          
                  <div *ngIf="formData.logType === 'Ultrasonic Log'">
                    <label class="fieldsHeading">Solutions Changed & Degassed</label>
                    <select 
                      class="w-full p-3 md:p-3 fields mt-2"
                      [(ngModel)]="formData.solutionsChanged">
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>
        

                
                 <div>
                 
                  <div>
                    <label class="fieldsHeading">Test Result</label>
                    <select 
                      class="w-full p-3 md:p-3 fields mt-2"
                      [(ngModel)]="formData.testResult">
                      <option value="Pass">Pass</option>
                      <option value="Fail">Fail</option>
                    </select>
                  </div>
              </div>


              <div>
                <label class="fieldsHeading">Team Members</label>
                <app-customcombobox 
                [items$]="technicians$" 
                placeholder="Type Or Select Team Member" 
                (selectionChange)="onTechnicianSelected($event)"
                [hasError]="hasError('technician')"
                ></app-customcombobox>
              </div>

              <div *ngIf="!showOtherEfficacyField">
                <label class="fieldsHeading">Efficacy Test Type</label>
                <app-customcombobox 
                [items$]="efficacyTestTypes$" 
                placeholder="Select Efficacy Test Type" 
                (selectionChange)="onEfficacyTestTypeSelected($event)"
                [hasError]="hasError('efficacyTestType')"
                ></app-customcombobox>
              </div>

              <div *ngIf="showOtherEfficacyField">
                <label class="fieldsHeading">Other Efficacy Test Type</label>
                <input 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  [ngClass]="{'border-red-500': hasError('otherEfficacyTestType')}"
                  type="text" 
                  placeholder="Add New Efficacy Test"
                  [(ngModel)]="formData.otherEfficacyTestType"
                />
                <p *ngIf="hasError('otherEfficacyTestType')" class="text-red-500 text-sm mt-1">
                  Please enter the custom efficacy test type
                </p>
              </div>
              </div>
         
           
              <div class="flex flex-col sm:flex-row gap-4 mt-10 mb-6">
                <button 
                  class="savebtn text-white px-8 py-2"
                  [disabled]="isSubmitting"
                  (click)="onSaveClick()">
                  {{ isSubmitting ? 'Saving...' : 'Save' }}
                </button>
              </div>
              
          
            
  
          
              </div>
          
             
            </div>
         
        </main>
      </div>
    </div>
  
    <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup>
  </div>